<template>
  <div class="footer-wrapper">
    <!-- Wavy SVG divider -->
    <div class="footer-top" aria-label="Decorative footer divider">
      <svg viewBox="0 0 1439 168" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_4523_19041)">
          <path
            d="M1607 604.292L1607 61.3777C1607 61.3777 1275 106.298 649.5 28.3374C137.944 -35.4216 -170 28.3374 -170 28.3374L-170 604.292L1607 604.292Z"
            fill="#30384A"
          />
        </g>
        <defs>
          <clipPath id="clip0_4523_19041">
            <rect width="1440" height="168" fill="white" transform="translate(-1)" />
          </clipPath>
        </defs>
      </svg>
    </div>
    <div class="footer-main">
      <div class="footer-col">
        <span class="image-wrapper">
          <img src="@/assets/images/investec-zebra.png" alt="Descriptive Alt Text" />
        </span>
        <!-- Country dropdown -->
        <div class="country-dropdown-wrapper"></div>
        <!-- Social icons -->
        <div class="social-links-wrapper">
          <a
            v-for="{ name, url, svgName } in socialLinks"
            :key="name"
            @click="invsyLink(url)"
            :aria-label="name"
            target="_blank"
            role="link"
            rel="noopener noreferrer"
            class="social-link"
          >
            <img :src="getIcon(svgName)" :alt="name" class="social-icon" />
          </a>
        </div>
      </div>
      <!-- Link Columns -->
      <div class="footer-col" v-for="{ heading, links } in linkGroups" :key="heading">
        <h3>{{ heading }}</h3>
        <ul>
          <li v-for="{ name, url } in links" :key="name">
            <a v-if="name != 'Contact us'"  @click="invsyLink(url)">{{ name }}</a>
            <a v-else :href="url">{{ name }}</a>
          </li>
        </ul>
      </div>
    </div>
    <!-- Bottom bar -->
    <div class="footer-bottom">
      <div class="footer-bottom-inner">
        &copy; {{ companyName }} {{ new Date().getFullYear() }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FooterDesktop",
  data() {
    return {
      companyName: "Investec",
      linkGroups: [
        // Legal information
        {
          heading: "Legal information",
          links: [
            {
              name: "Accessibility",
              url: "https://www.investec.com/en_za/accessibility.html",
            },
            { name: "Legal", url: "https://www.investec.com/en_za/legal/SA.html" },
            {
              name: "Fraud",
              url: "https://www.investec.com/en_za/legal/know-fraud.html",
            },
            {
              name: "Privacy policy",
              url: "https://www.investec.com/en_za/legal/privacy-policy.html",
            },
            {
              name: "Terms and conditions",
              url: "https://www.investectravel.com/terms-and-conditions/",
            },
          ],
        },
        // Get in touch
        {
          heading: "Get in touch",
          links: [
            { name: "Contact us", url: "https://www.investectravel.com/contact-us/" },
            {
              name: "Careers",
              url: "https://www.investec.com/en_za/welcome-to-investec/Careers.html",
            },
          ],
        },
        // Other information
        {
          heading: "Other information",
          links: [
            {
              name: "Investec Property",
              url: "https://www.investecproperty.com/en_za.html",
            },
            { name: "Developer", url: "https://developer.investec.com/za/home" },
            {
              name: "Clarity by Investec",
              url:
                "https://nowclarity.com/?medium=referral&source=website-investec.com&campaign=sa-cly-investec-dot-com-referrals&content=from-footer&up_id=390126a",
            },
          ],
        },
      ],
      socialLinks: [
        {
          name: "facebook",
          svgName: "facebook-icon",
          url: "https://www.facebook.com/InvestecBank/",
        },
        { name: "twitter", svgName: "twitter-icon", url: "https://twitter.com/Investec" },
        {
          name: "linkedin",
          svgName: "linkedin-icon",
          url: "https://www.linkedin.com/company/investec",
        },
        {
          name: "instagram",
          svgName: "instagram-icon",
          url: "https://www.instagram.com/investec/",
        },
        {
          name: "youtube",
          svgName: "youtube-icon",
          url: "https://www.youtube.com/user/investec",
        },
      ],
    };
  },
  methods: {
    invsyLink(url) {
      this.$store.dispatch("invsyLink", url);
    },
    getIcon(path) {
      return require(`@/assets/images/icons/${path}.svg`);
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/variables.scss";

$footer-padding: 16px;
$footer-margin: 32px;
.footer-wrapper {
  margin-top: $footer-margin;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.footer-main {
  display: flex;
  justify-content: space-between;
  width: 100%;
  background-color: #303849;
  color: #fff;
  padding: 4 * $footer-padding;
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: normal;
}

.footer-top {
  margin-bottom: -5px;
  width: 100%;
  background: none;
  overflow: hidden;

  svg {
    display: block;
    width: 100%;
    height: auto;
  }
}

.footer-col {
  flex: 1;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  line-height: 24px;
  padding-left: $footer-padding;
  padding-right: $footer-padding;

  .image-wrapper {
    display: flex;
    padding-left: 20px;
    padding-right: 20px;

    img {
      width: 212px;
      height: auto;
    }
  }

  .social-links-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-top: auto;
    height: 100%;

    .social-link {
      display: flex; // Turn each link into a flex container
      justify-content: center; // Center the icons horizontally
      align-items: center;

      .social-icon {
        width: 24px;
        height: 24px;
      }
    }
  }

  h3 {
    font-weight: 600;
    width: 290px;
    height: 24px;
    margin-bottom: 40px;
    font-family: sans-serif;
    color: #fff;
    opacity: 0.5;
    font-size: 16px;
  }

  ul {
    list-style: none !important;
    padding: 0;
    border-left: 1.5px solid rgba(255, 255, 255, 0.25);
    padding-left: 16px;

    li {
      margin-bottom: 32px;

      a {
        text-decoration: underline;
        color: #fff;
        font-weight: 600;
        &:hover {
          text-decoration: underline;
        }
      }

      a:hover {
        padding-left: 1rem;
        // smooth transition for hover effect back and forward
        transition: all 0.1s ease-in-out;
      }
    }
  }
}

.footer-bottom {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: left;
  padding: 0 4 * $footer-padding $footer-margin;
  background-color: #303849;

  .footer-bottom-inner {
    width: 100%;
    padding: 16px 0;
    border-top: 1.5px solid rgba(255, 255, 255, 0.25);
    color: rgba(255, 255, 255, 0.8);
    font-family: "Inter", sans-serif;
    font-size: 14px;
    line-height: 20px;
    font-weight: 500;
  }
}

// Responsive design preparation
@media (max-width: 768px) {
  .footer-main {
    flex-direction: column;
  }
  .footer-col {
    margin-bottom: $footer-margin;
  }
}

@media (max-width: 480px) {
  .footer-main {
    padding: 2 * $footer-padding;
  }
}
</style>
